import { render, staticRenderFns } from "./PcContent.vue?vue&type=template&id=23e81ed4"
import script from "./PcContent.vue?vue&type=script&lang=js"
export * from "./PcContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports